module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--5-7d92f2af.png";